<template>
    <div v-if="loaded">
        <VerificaIscrizione :data="data"/>
    </div>
</template>

<script>
    import { Trans } from '@/plugins/Translation'
    import BaseVue from "./BaseVue"
    import VerificaIscrizione from '../components/VerificaIscrizione'


    export default {
        extends: BaseVue,
        name: 'iframe-verificaiscritti',
        components: {
            VerificaIscrizione,
        },
        data() {
            return {
                id:null,
                data: null,
                loaded: false
            }
        },
        async mounted() {
            this.id = this.$route.params.id
            let data = await this.get(this.id + '/light', true)
            this.data = data.RaceDetails
            this.loaded = true
        }, computed: {
            currentLanguage () {
                return Trans.currentLanguage
            },

        }, methods: {

        }
    }
</script>
